import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';

import { IPostgreCvViewAggrDTO } from '../../jobs/types/postgreJobsDTO';
import { ICvViewWidgetProp } from '../../jobs/types/postgreJobsWidgetProp';
import { usePostgreCvViewWidgetsData } from '../hooks/usePostgreCvViewWidgetsData';
import { defaultCvViewWidgetData } from '../utils/cvViewHelper';

const CvViewBarChartPostgre = ({ query, title }: ICvViewWidgetProp) => {
  const widgetData = usePostgreCvViewWidgetsData<IPostgreCvViewAggrDTO>(
    query,
    defaultCvViewWidgetData
  );

  const dateTimes: string[] = Object.keys(widgetData.countByDate as Record<string, number>);
  const barData = dateTimes.map((dateTime) => ({
    x: dateTime,
    y: (widgetData.countByDate as Record<string, number>)[dateTime],
  }));

  const options: ApexOptions = {
    chart: {
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      type: 'datetime',
      labels: {
        datetimeUTC: false,
      },
      categories: dateTimes ?? [],
    },
    yaxis: {
      title: {
        text: 'Count',
      },
    },
    dataLabels: {
      enabled: false,
    },
    title: {
      text: title,
      style: {
        fontSize: '12px',
      },
    },
  };

  const series: ApexAxisChartSeries = [
    {
      data: barData ?? [],
      name: title,
    },
  ];

  return <ReactApexChart options={options} series={series} type="bar" width="100%" height="100%" />;
};

export default CvViewBarChartPostgre;
